/**
 * Access Control Store Module
 *
 * Manages user permissions and Auth0 user management.
 * Provides functionality to:
 * - Fetch users with pagination and search
 * - Add, update, and delete users
 * - Transform role structures for UI display
 * - Maintain static copies for comparison
 *
 * @module store/modules/accesscontrol
 */

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";
import { Module } from "vuex/types";
import { AccessControlState } from "./types";
import { RootState } from "@/store/types";

const editor: Module<AccessControlState, RootState> = {
  namespaced: false,
  getters,
  state,
  actions,
  mutations,
};

export default editor;
